import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
    setTransfersReportOpenRows,
    setTransfersReportRequestData,
    setTransfersReportResponseData, setTransfersReportSelectedRows
} from "../../../../../_reducers/DataPanel/Sales/transfersSlice";
import {Button, Col, Row, Spinner} from "react-bootstrap";
import axios from "axios";
import {toast} from "react-toastify";
import Pagination from "../../../../primer/Pagination";
import {
    formatDeliveryStatus,
    formatDeliveryStatusColor,
    transferStatusOptions
} from "./constants";
import {TransferInfo} from "./TransferInfo";
import moment from "moment";
import {isEmpty} from "../../../../../_helpers/commonFunctions";
import DateHelper from "../../../../primer/DateHelper/DateHelper";
import DateBox from "../../../../primer/DateBox";
import Dropdown from "../../../../primer/Dropdown";
import Input from "../../../../common/Input";
import MassFetchTransfersModal from "./MassFetchTransfersModal";
import {selfUpdateSaleByMark} from "../../../../../_helpers/tabUpdater";
import TransfersActionButtons from "./TransfersActionButtons";

const SearchTransfers = () => { // Transfers Report
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const requestData = useSelector((state) => state.TRANSFERS.transferReportRequestData);
    const responseData = useSelector((state) => state.TRANSFERS.transfersReportResponseData);
    const selectedRows = useSelector((state) => state.TRANSFERS.reportSelectedRows);
    const openRows = useSelector((state) => state.TRANSFERS.reportOpenRows);
    const editSales = useSelector((state) => state.SALES.editSales);

    const [pageChanged, setPageChanged] = useState(false);
    const [loading, setLoading] = useState(false);

    const [showMassFetchModal, setShowMassFetchModal] = useState(false);

    const invoiceRoles = [
        {label: "Οποιοσδήποτε", value: ""},
        {label: "Εκδότης", value: "issuer"},
        {label: "Μεταφορέας", value: "transporter"},
        {label: "Λήπτης", value: "counterpart"},
    ]

    const b2Options = [
        {label: "Προβολή όλων", value: ""},
        {label: "Μόνο B2B", value: "b2b"},
        {label: "Μόνο B2C", value: "b2c"},
    ]

    useEffect(() => {
        if (pageChanged) {
            setPageChanged(false);
            fetchReport(true);
        }
    }, [pageChanged])

    useEffect(() => {
        if (isEmpty(requestData.date_to) && isEmpty(requestData.date_from)) {
            const currentYear = Number(moment().format("YYYY"));
            if (Number(company.year) < currentYear) {
                dispatch(setTransfersReportRequestData({...requestData, date_from: `01/01/${company.year}`, date_to: `31/12/${company.year}`}));
            } else {
                dispatch(setTransfersReportRequestData({...requestData, date_from: moment().startOf("month").format("DD/MM/YYYY"), date_to: moment().endOf("month").format("DD/MM/YYYY")}));
            }
        }
    }, []);

    const fetchReport = (fromPagination = false) => {
        setLoading(true);
        const reqData = {...requestData};
        if (!fromPagination) {
            reqData.page = 1;
            dispatch(setTransfersReportRequestData(reqData));
        }
        axios.post(`${process.env.REACT_APP_API_URL2}/sale/transfers-report`, {
            ...reqData,
            company: company.id,
        }).then((res) => {
            if (res.data.status === "200") {
                dispatch(setTransfersReportResponseData({
                    ...responseData,
                    data: res.data.data,
                    totalItems: res.data.totalItems,
                    totalPages: res.data.totalPages,
                }))
                if (!fromPagination) {
                    if (res.data.data.length > 0) {
                        dispatch(setTransfersReportSelectedRows([]));
                        dispatch(setTransfersReportOpenRows([]));
                        toast.success("Επιτυχής ανανέωση.", {autoClose: 1000});
                    } else {
                        toast.info("Επιτυχής ανανέωση, δεν βρέθηκαν Δ.Α.", {autoClose: 2000});
                    }
                }
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        }).finally(() => {
            setLoading(false);
        })
    }

    const onPageChange = (page) => {
        setPageChanged(true);
        dispatch(setTransfersReportRequestData({...requestData, page}));
    }

    const handleOnChange = (e, type, name) => {
        const prepChange = {};
        if (type === "datebox") {
            if (moment(e).isValid()) {
                prepChange[name] = moment(e).format("DD/MM/YYYY");
            } else {
                prepChange[name] = "";
            }
        } else if (type === "msdd") {
            prepChange[name] = e.flatMap((o) => o.value);
        } else if (type === "input") {
            prepChange[name] = e.target.value;
        } else if (type === "dd") {
            prepChange[name] = e.value;
        }
        dispatch(setTransfersReportRequestData({...requestData, ...prepChange}));
    }

    const handleSelectAll = () => {
        axios.post(`${process.env.REACT_APP_API_URL2}/sale/transfers-report`, {
            ...requestData,
            page: -1,
            company: company.id,
        }).then((res) => {
            if (res.data.status === "200") {
                dispatch(setTransfersReportSelectedRows(res.data.data));
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        });
    }

    return (
        <div>
            <div onKeyDown={(e) => {
                if (e.key === "Enter") fetchReport(false);
            }}>
                <Row className={"mb-2"}>
                    <Col md={2}>
                        <DateHelper
                            dateFromAndToFunction={(from, to) => {
                                dispatch(setTransfersReportRequestData({...requestData, date_from: from, date_to: to}));
                            }}
                        />
                    </Col>
                    <Col md={1}>
                        <DateBox
                            name={"date_from"}
                            selected={isEmpty(requestData.date_from) ? moment().toDate() : moment(requestData.date_from, "DD/MM/YYYY").toDate()}
                            label={"Ημερομηνία από"}
                            onChange={(e) => handleOnChange(e, "datebox", "date_from")}
                        />
                    </Col>
                    <Col md={1}>
                        <DateBox
                            name={"date_to"}
                            selected={isEmpty(requestData.date_to) ? moment().toDate() : moment(requestData.date_to, "DD/MM/YYYY").toDate()}
                            label={"Ημερομηνία έως"}
                            onChange={(e) => handleOnChange(e, "datebox", "date_to")}
                        />
                    </Col>
                    <Col md={3}>
                        <Dropdown
                            name={"status"}
                            label={"Κατάσταση"}
                            options={transferStatusOptions}
                            multiSelect={true}
                            key={Math.random()}
                            defaultValue={transferStatusOptions.filter((el) => requestData.status.includes(el.value))}
                            onChange={(e) => handleOnChange(e, "msdd", "status")}
                        />
                    </Col>
                    <Col md={5}>
                        <Input
                            name={"general"}
                            label={"Γενικό Φίλτρο"}
                            value={requestData.general}
                            charLimit={200}
                            placeholder={"Εισάγετε αρίθμηση/σειρά/αντισυμβαλλόμενη οντότητα/Μ.ΑΡ.Κ."}
                            onChange={(e) => handleOnChange(e, "input", "general")}
                        />
                    </Col>
                </Row>
                <Row className={"mb-2"}>
                    <Col md={3}>
                        <Dropdown
                            name={"invoiceRole"}
                            label={"Ρόλος της επιχείρησης μου"}
                            options={invoiceRoles}
                            defaultValue={invoiceRoles.find((el) => el.value === requestData.invoiceRole)}
                            onChange={(e) => handleOnChange(e, "dd", "invoiceRole")}
                        />
                    </Col>
                    <Col md={3}>
                        <Dropdown
                            name={"b2Option"}
                            label={"Φίλτρο B2B/B2C"}
                            options={b2Options}
                            defaultValue={b2Options.find((el) => el.value === requestData.b2Option)}
                            onChange={(e) => handleOnChange(e, "dd", "b2Option")}
                        />
                    </Col>
                    <Col md={6} className={"d-flex justify-content-end"}>
                        <Button className={"mr-2"} style={{maxHeight: "45px"}} onClick={() => setShowMassFetchModal(true)} disabled={loading}>
                            Άντληση myDATA
                        </Button>
                        <Button style={{maxHeight: "45px"}} onClick={() => fetchReport(false)} disabled={loading}>
                            Ανανεώση {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                        </Button>
                    </Col>
                </Row>
            </div>
            {responseData.totalPages > 0 && (
                <React.Fragment>
                    <Row className={"mb-2"}>
                        <Col md={12} className="d-flex flex-column flex-md-row justify-content-end align-items-center align-items-md-start">
                            <div className="mr-md-3 mt-2 mb-2 mb-md-0 text-center text-md-right">
                                <i style={{ whiteSpace: 'nowrap' }}>
                                    Σύνολο Αποτελεσμάτων: {responseData.totalItems}
                                </i>
                            </div>
                            <div className="d-flex justify-content-center justify-content-md-end">
                                <Pagination
                                    currentPage={requestData.page}
                                    totalPages={responseData.totalPages}
                                    handlePageChange={(e) => onPageChange(e)}
                                    maxWidth={400}
                                />
                            </div>
                        </Col>
                        <Col md={12}>
                            <table className={"transfers-table"}>
                                <thead>
                                <tr>
                                    <th data-label="Επιλογή Όλων" onClick={() => {
                                        if (selectedRows.length === responseData.totalItems) {
                                            dispatch(setTransfersReportSelectedRows([]));
                                        } else {
                                            handleSelectAll();
                                        }
                                    }}>
                                        <input type={"checkbox"} className={"mt-1"} style={{zoom: 1.5}} checked={selectedRows.length === responseData.totalItems} />
                                    </th>
                                    <th>Ημ/νια Έκδοσης</th>
                                    <th>Εκδότης</th>
                                    <th>Λήπτης</th>
                                    <th>Μ.ΑΡ.Κ.</th>
                                    <th>Παραστατικό</th>
                                    <th>B2B / B2C</th>
                                    <th>Κατάσταση</th>
                                </tr>
                                </thead>
                                <tbody>
                                {responseData.data.map((t, idx) => (
                                    <React.Fragment key={`trep-group-${idx}`}>
                                        <tr
                                            key={`trep-${idx}`}
                                            style={{cursor: "pointer"}}
                                            onClick={() => {
                                                if (openRows.includes(t.qrUrl)) {
                                                    dispatch(setTransfersReportOpenRows(openRows.filter((el) => el !== t.qrUrl)));
                                                } else {
                                                    dispatch(setTransfersReportOpenRows([...openRows, t.qrUrl]));
                                                }
                                            }}
                                        >
                                            <td
                                                data-label="Επιλογή"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    if (selectedRows.some((el) => el.qrUrl === t.qrUrl)) {
                                                        dispatch(setTransfersReportSelectedRows(selectedRows.filter((el) => el.qrUrl !== t.qrUrl)));
                                                    } else {
                                                        dispatch(setTransfersReportSelectedRows([...selectedRows, t]));
                                                    }
                                                }}
                                            >
                                                <input type={"checkbox"} className={"mt-1"} style={{zoom: 1.5}} checked={selectedRows.some((el) => el.qrUrl === t.qrUrl)} />
                                            </td>
                                            <td data-label="Ημ/νια Έκδοσης">{moment(t.invoiceDate).format("DD/MM/YYYY")}</td>
                                            <td data-label="Εκδότης">{t.issuerName}</td>
                                            <td data-label="Λήπτης">{t.counterpartName}</td>
                                            <td data-label="Μ.ΑΡ.Κ.">{t.invoiceMark}</td>
                                            <td data-label="Παραστατικό">{t.documentLabel}</td>
                                            <td data-label="B2B / B2C">{t.isB2B ? "B2B" : "B2C"}</td>
                                            <td data-label="Κατάσταση" style={{backgroundColor: formatDeliveryStatusColor(t.myDataStatus)}}>
                                                {formatDeliveryStatus(t.myDataStatus)}
                                            </td>
                                        </tr>
                                        {openRows.includes(t.qrUrl) && (
                                            <tr key={`tr-d-${idx}-o`} style={{backgroundColor: "#f2f2f2"}}>
                                                <td colSpan={9}>
                                                    <TransferInfo
                                                        transferData={t}
                                                        refreshCallback={() => {
                                                            fetchReport(true);
                                                            // Self-update sales
                                                            const marks = selectedRows.map((o) => String(o.invoiceMark));
                                                            for (const mark of marks) selfUpdateSaleByMark(dispatch, editSales, company.id, mark);
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                ))}
                                </tbody>
                            </table>
                        </Col>
                    </Row>

                    <TransfersActionButtons
                        selectedRows={selectedRows}
                        successCallback={() => {
                            fetchReport(true);
                            // Self-update sales
                            const marks = selectedRows.map((o) => String(o.invoiceMark));
                            for (const mark of marks) selfUpdateSaleByMark(dispatch, editSales, company.id, mark);
                        }}
                    />
                </React.Fragment>
            )}

            <MassFetchTransfersModal
                show={showMassFetchModal}
                setShow={setShowMassFetchModal}
                successCallback={() => {
                    fetchReport(true);
                }}
            />
        </div>
    )
}

export default SearchTransfers;
